export default __webpack_public_path__ + "static/loans-to-go-logo-91f34a38dcc4433233ec8cb5449bfc09.webp";